import { gql } from '@apollo/client';

export default gql`
  mutation deleteDCategory($_id: String) {
    deleteDCategory(_id: $_id) {
      ok
      message
      error
    }
  }
`;
